export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:8080';

export const COMPANY_STATUSES = ['Active', 'Inactive', 'Suspended'];
export const ADMIN_STATUSES = ['Active', 'Suspended'];
export const LIMIT_REQUEST_STATUSES = ['Pending', 'Approved', 'Rejected'];
